import i18n from '@/i18n'

export const STATIC_OPTION_TYPE = [
  {
    get label () {
      return i18n.t(`admin.crm.survey.optionType.${this.value}`)
    },
    value: 'city'
  },
  {
    get label () {
      return i18n.t(`admin.crm.survey.optionType.${this.value}`)
    },
    value: 'job_type'
  },
  {
    get label () {
      return i18n.t(`admin.crm.survey.optionType.${this.value}`)
    },
    value: 'role_type'
  },
  {
    get label () {
      return i18n.t(`admin.crm.survey.optionType.${this.value}`)
    },
    value: 'custom'
  }
]

export const ACCEPT_FILE_TYPE = [
  'image/png',
  'image/jpeg',
  'image/gif',
  'image/jpg'
]

export const ACCEPT_FILE_SIZE = 5 * 1024 * 1024 // 5MB
